export enum OnboardingStatus {
  Unknown = 'Unknown',
  NotOnboarded = 'NotOnboarded',
  Onboarded = 'Onboarded',
  RequiresReonboarding = 'RequiresReonboarding',
  NoAdAccountsConfigured = 'NoAdAccountsConfigured'
}